import {ChevronLeft, ChevronRight} from '@nlabs/gothamjs/icons';
import {useState} from 'react';

const updates = [
  'Morning briefing: What Chicago is watching today',
  'Public meetings and city notices for Thursday',
  'Air quality is good; lake breeze expected this afternoon'
];

export const NewsFlash = () => {
  const [index, setIndex] = useState(0);
  const move = (direction: number) => setIndex((index + direction + updates.length) % updates.length);
  return (
    <div className="newsflash">
      <div className="shell newsflash__inner">
        <span className="newsflash__label">City Desk</span>
        <a href="#latest">{updates[index]}</a>
        <div className="newsflash__controls">
          <button onClick={() => move(-1)} aria-label="Previous update"><ChevronLeft size={16} /></button>
          <span>{index + 1} / {updates.length}</span>
          <button onClick={() => move(1)} aria-label="Next update"><ChevronRight size={16} /></button>
        </div>
      </div>
    </div>
  );
};
